<template>
  <v-container class="container-terms">
    <img :src="omr.omr_link"/>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "Terms-and-condtions",
  mounted() {},
  data() {
    return {omr:null};
  },
  mounted() {
    this.getOmr()
  },
  methods: {
    ...mapActions({ getOmrById: "testStore/getOmrById" }),
    getOmr(){
        this.getOmrById(this.$route.params.id)
            .then(response=>{
                this.omr=response
            })
            .catch(err=>{
                console.log(err);
            })
    }
  },
};
</script>
